<template>
    <div class="w-full pt-6">
      <BaseButton type="neutral" @click="navigateToEvent()" v-if="checkout.event.visibility === EventVisibility.public">
        {{ $t('modal.expired_timer.return') }}
      </BaseButton>
    </div>
</template>
<script lang="ts" setup>
import {useCheckoutStore} from "~/store/checkout"
import {EventVisibility} from "~/utils/types/event.d"

const checkout = useCheckoutStore()

const modelValue = useAttrs().modelValue as ModalModel
modelValue.title="modal.expired_timer.title"
modelValue.subtitle="modal.expired_timer.description"
modelValue.icon_text="00:00"
modelValue.icon_classes="!text-red-700"
modelValue.icon_wrapper_classes="bg-red-100 text-red-700 w-20 text-base font-medium"
modelValue.dismissable=false
</script>
